export default {"src":"/_next/static/media/ong.85091d64.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};